import { MoveRight, LoaderCircle } from "lucide-react";
import { handleErrMessage } from "../../functions/handleErrMessage";
import CustomInput from "../../components/UI/PageInput/CustomInput";
import { phoneValidation } from "../../validations/formValidations";

const OtpSendForm = ({ register, errors, loading, error }) => {
  return (
    <>
      <img src="/logo.svg" alt="logo" className="login-logo" />
      <h3 className="login-heading">Welcome to JBCC</h3>
      <p className="md:pb-7 pb-4 max-sm:text-center max-md:text-sm text-gray-600">
        Enter your phone number to continue.
      </p>
      <CustomInput
        type="text"
        name="phone"
        labelText="Mobile Number"
        placeholder="Enter Mobile"
        register={register("phone", {
          required: "Mobile number is required",
          ...phoneValidation,
        })}
        error={errors.phone}
      />

      {error && <p className="loginOtpErr">{handleErrMessage(error)}</p>}

      <button className="loginBtn hover:bg-db2" disabled={loading}>
        {loading ? (
          <>
            <LoaderCircle className="animate-spin mr-2" size={25} /> Loading...
          </>
        ) : (
          <>
            GET OTP
            <MoveRight className="ml-2" />
          </>
        )}
      </button>
    </>
  );
};

export default OtpSendForm;
